import React,{Component} from 'react';
import {TextField,Select,MenuItem,Table,IconButton,Icon,
    TableRow,TableHead,TableBody,TableCell,
    Button,} from '@material-ui/core';

import IIBB from '../pdfs/RetencionIIBB';
import Ganancias from '../pdfs/RetencionGanancias';
import SUSS from '../pdfs/RetencionSUSS';

import ICONODESCARGA from '@material-ui/icons/ArrowDropDownCircle';
import DBHandler from '../DBHandler';

export default class ListadoRetenciones extends Component{
    constructor(props){
        super(props);
        this.state = {
            repas:[],
            retenciones:{},
            seleccionado:null,
        }
    }

    actualizarDatos(datos){
        let repas = datos['repas'];
        let retenciones = datos['retenciones']; //diccionario donde el nº de repa es la clave 
        this.setState({
            repas:repas,
            retenciones:retenciones
        })
    }

    seleccionar(muestra){
        this.setState({
            seleccionado:muestra
        })
    }


    render(){
        return (<div style={{margin:'10px'}}>
            <Filtrado
                cargarDatos={this.actualizarDatos.bind(this)}
            ></Filtrado>
            {this.state.seleccionado !== null ? 
            <div>
                <Button onClick={()=>this.setState({seleccionado:null})}
                color='secondary' fullWidth variant='contained'
                >volver</Button>
                {this.state.seleccionado}
                </div> : 
            <Listado  repas={this.state.repas} retenciones={this.state.retenciones}
                seleccionar={this.seleccionar.bind(this)}
            />}
            
        </div>)
    }

}

class Listado extends Component{
    constructor(props){
        super(props);
        this.state={
            repas:props.repas,
            retenciones:props.retenciones,
        }
        this.seleccionar = props.seleccionar;

    }

    componentWillReceiveProps(props){
        this.setState({
            repas:props.repas,
            retenciones:props.retenciones,
        })
    }

    render(){
        return <div>
            <Table size='small'>
                <TableHead>
                    <TableRow>
                        <TableCell>
                            Nº Repa
                        </TableCell>
                        <TableCell>
                            Ejercicio
                        </TableCell>
                        <TableCell>
                            IIBB
                        </TableCell>
                        <TableCell>
                            Ganancias
                        </TableCell>
                        <TableCell>
                            SUSS
                        </TableCell>
                        <TableCell>
                            Comprobantes
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {this.state.repas.map((elem,ind)=><LineaTabla repa={elem} key={ind}
                        retenciones={this.state.retenciones[elem]}
                        seleccionar={this.seleccionar}
                    />)}
                </TableBody>
            </Table>
        </div>
    }
}

class LineaTabla extends Component{
    constructor(props){
        super(props);
        this.state={
            repa:props.repa,
            retenciones:props.retenciones
        }
        this.seleccionar = props.seleccionar;
    }

    componentWillReceiveProps(props){
        this.setState({
            repa:props.repa,
            retenciones:props.retenciones
        })
    }

    descargar(archivo){
        
        
        let con = new XMLHttpRequest();
        con.open('POST','https://serweb.presidenteperon.gov.ar/provret/comprobantes/devolver',true);
        con.responseType = 'blob';
        con.onload = function(event){
            let blob = con.response;
            let nombre = archivo;
            let link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = nombre;
            link.click();
        }
        con.setRequestHeader('Content-type','application/json')
        con.send(JSON.stringify({'archivo':archivo}));
    }

    render(){
        return <TableRow>
            <TableCell>
                {this.state.repa.substr(4)}
            </TableCell>
            <TableCell>
                {this.state.repa.substr(0,4)}
            </TableCell>
            <TableCell>
                {this.state.retenciones['IIBB'] !== null ? <IconButton  style={{display:'inline-block'}} size='small' 
                    onClick={
                        ()=>{
                            let act = this.state.retenciones['IIBB']
                            this.seleccionar(<IIBB 
                                    op={act.nro_op}
                                    tipo_deduc={act.codigo_deduc}
                                    ejercicio={act.ejercicio}
                                    tabla={act.tabla}
                                />)}
                    } >
                        <Icon> <ICONODESCARGA/> </Icon>
                    </IconButton>:null}
            </TableCell>
            <TableCell>
                {this.state.retenciones['Ganancias'] !== null ? <IconButton  style={{display:'inline-block'}} size='small' 
                    onClick={
                        ()=>{
                            let act = this.state.retenciones['Ganancias']
                            this.seleccionar(<Ganancias 
                                    op={act.nro_op}
                                    tipo_deduc={act.codigo_deduc}
                                    ejercicio={act.ejercicio}
                                />)}
                    } >
                        <Icon> <ICONODESCARGA/> </Icon>
                    </IconButton>:null}
            </TableCell>
            <TableCell>
                {this.state.retenciones['SUSS'] !== null ? <IconButton  style={{display:'inline-block'}} size='small' 
                    onClick={
                        ()=>{
                            let act = this.state.retenciones['SUSS']
                            this.seleccionar(<SUSS 
                                    op={act.nro_op}
                                    tipo_deduc={act.codigo_deduc}
                                    ejercicio={act.ejercicio}
                                />)}
                    } >
                        <Icon> <ICONODESCARGA/> </Icon>
                    </IconButton>:null}
            </TableCell>
            <TableCell>
                {this.state.retenciones['Comprobantes'].map((elem,ind)=><IconButton  style={{display:'inline-block'}} size='small' 
                    onClick={
                        ()=>{this.descargar.bind(this)(elem.nro_deduc)}
                    } >
                        <Icon> <ICONODESCARGA/> </Icon>
                    </IconButton>)}
            </TableCell>
        </TableRow>
    }
}



class Filtrado extends Component{
    constructor(props){
        super(props);
        this.state={
            proveedor:'',
            desde: new Date().getFullYear() + '-01-01',
            hasta:'',
        }
        this.db = new DBHandler();
        this.cargarDatos = props.cargarDatos;
    }


    pedirDatos(){
        this.db.enviarPeticion(
            this.cargarDatos,
            'retenciones/listaradmin',
            'POST',
            {
                proveedor:this.state.proveedor,
                desde:this.state.desde,
                hasta:this.state.hasta,
            }
        )
    }

    render(){
        return <div style={{marginTop:'15px',marginBottom:'10px'}}>
            <TextField
                value={this.state.proveedor}
                variant='outlined'
                type='number' size='small'
                label='Proveedor'
                onChange={(ev)=>this.setState({
                    proveedor:ev.target.value
                })}
            ></TextField>
            <TextField size='small'
                value={this.state.desde}
                variant='outlined'
                type='date'
                label='Desde'
                onChange={(ev)=>this.setState({
                    desde:ev.target.value
                })}
                InputLabelProps={{
                    shrink: true,
                  }}
            ></TextField>
            <TextField size='small'
                value={this.state.hasta}
                variant='outlined'
                type='date'
                label='Hasta'
                onChange={(ev)=>this.setState({
                    hasta:ev.target.value
                })}
                InputLabelProps={{
                    shrink: true,
                  }}
            ></TextField>
            <Button variant='contained'
                color='primary'
                onClick={this.pedirDatos.bind(this)}
            >
                Pedir Datos
            </Button>
        </div>
    }
}